import React, { Fragment } from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
export default function CustomDeleteButton(props){  
    const {keyvalue} = props;  
    return(
        <Fragment>
            <Button className='action-btn' color='danger' id={`tooltip_delete_key_${keyvalue}`} {...props}>
                <span className='far fa-trash-alt'></span>
            </Button>
            <UncontrolledTooltip placement="top" target={`tooltip_delete_key_${keyvalue}`}>
                Remove
            </UncontrolledTooltip>
        </Fragment>
    );
}